/**
 * Daily Report MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import {
  DAILY_SNAPSHOT_QUERY_KEY,
  fetchDailySnapshotFromApi,
} from "./dailyReportQueryApi";

export const dailyReportQueryClient = makeMv2QueryClient();

export function prefetchDailyReport(date) {
  if (!date) return Promise.resolve();
  return dailyReportQueryClient.prefetchQuery({
    queryKey: [DAILY_SNAPSHOT_QUERY_KEY, date],
    queryFn: ({ signal }) => fetchDailySnapshotFromApi(date, signal),
  });
}
